import { isMarketingMockEnabled } from './is-marketing-mock-enabled';

export function getMarketingMockQueryOptions<T>(mockData: T | undefined) {
  if (!isMarketingMockEnabled() || mockData === undefined) {
    return {};
  }

  return {
    queryFn: () => Promise.resolve(mockData),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  };
}
